var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19 6.5c.275 0 .5.225.5.5v1h-15V7c0-.275.225-.5.5-.5zm.5 4.5v6c0 .275-.225.5-.5.5H5a.5.5 0 0 1-.5-.5v-6zM5 5c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zm1.75 9.5a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h1.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75zm4 0a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h3.5c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75z"
  })));
};
export default SvgCreditCard;